/*!

=========================================================
* BLK Design System React - v1.2.2
=========================================================

* Product Page: https://www.creative-tim.com/product/blk-design-system-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/blk-design-system-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// reactstrap components
import { Container, Row, Col } from "reactstrap";

export default function TeckStack() {
  return (
    <div id="tech-stack" className="section section-nucleo-icons">
      <img alt="..." className="path" src={require("assets/img/path3.png")} />
      <Container>
        <Row className="justify-content-center">
          <Col lg="8" md="12">
            <h2 className="title">Tech Stack</h2>
          </Col>
        </Row>

        <Row className="mt-5 mt-sm-5 text-center">
          <Col sm="3" xs="6" className="p-2">
            <img
              id="html5"
              alt="..."
              className="img-fluid rounded shadow pointer"
              src={require("assets/img/icons8-html5-100.png")}
              style={{ width: "50px" }}
            />
          </Col>
          <Col sm="3" xs="6" className="p-2">
            <img
              id="css3"
              alt="..."
              className="img-fluid rounded shadow pointer"
              src={require("assets/img/icons8-css3-100.png")}
              style={{ width: "50px" }}
            />
          </Col>
          <Col sm="3" xs="6" className="p-2">
            <img
              id="js"
              alt="..."
              className="img-fluid rounded shadow pointer"
              src={require("assets/img/icons8-javascript-100.png")}
              style={{ width: "50px" }}
            />
          </Col>
          <Col sm="3" xs="6" className="p-2">
            <img
              id="mongo"
              alt="..."
              className="img-fluid rounded shadow pointer"
              src={require("assets/img/icons8-mongo-100.png")}
              style={{ width: "50px" }}
            />
          </Col>
          <Col sm="3" xs="6" className="p-2">
            <img
              id="react"
              alt="..."
              className="img-fluid rounded shadow pointer"
              src={require("assets/img/icons8-react-100.png")}
              style={{ width: "50px" }}
            />
          </Col>
          <Col sm="3" xs="6" className="p-2">
            <img
              id="react-native"
              alt="..."
              className="img-fluid rounded shadow pointer"
              src={require("assets/img/icons8-react-native-100.png")}
              style={{ width: "50px" }}
            />
          </Col>
          <Col sm="3" xs="6" className="p-2">
            <img
              id="postgresql"
              alt="..."
              className="img-fluid rounded shadow pointer"
              src={require("assets/img/icons8-postgresql-100.png")}
              style={{ width: "50px" }}
            />
          </Col>
          <Col sm="3" xs="6" className="p-2">
            <img
              id="digitalocean"
              alt="..."
              className="img-fluid rounded shadow pointer"
              src={require("assets/img/icons8-digital-ocean-100.webp")}
              style={{ width: "45px" }}
            />
          </Col>
          <Col sm="3" xs="6" className="p-2">
            <img
              id="java"
              alt="..."
              className="img-fluid rounded shadow pointer"
              src={require("assets/img/icons8-java-100.png")}
              style={{ width: "50px" }}
            />
          </Col>
          <Col sm="3" xs="6" className="p-2">
            <img
              id="nodejs"
              alt="..."
              className="img-fluid rounded shadow pointer"
              src={require("assets/img/icons8-nodejs-100.png")}
              style={{ width: "50px" }}
            />
          </Col>

          <Col sm="3" xs="6" className="p-2">
            <img
              id="nodejs"
              alt="..."
              className="img-fluid rounded shadow pointer"
              src={require("assets/img/icons8-azure-100.png")}
              style={{ width: "50px" }}
            />
          </Col>
          <Col sm="3" xs="6" className="p-2">
            <img
              id="nodejs"
              alt="..."
              className="img-fluid rounded shadow pointer"
              src={require("assets/img/icons8-ble-100.png")}
              style={{ width: "50px" }}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}
